import OtpInput from "react-otp-input";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import loginHero from "../assets/home/login-logo.svg";
import homeLogo from "../assets/home/home.svg";
import axiosInstance from "../apiInstances/axiosInstance";

const VerifyOtp = () => {
  const [otp, setOtp] = useState("");
  const [newEmail, setNewEmail] = useState(null);
  const [oldEmail, setOldEmail] = useState(null);
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);


  useEffect(() => {
    const storedNewEmail = localStorage.getItem("newEmail");
    setNewEmail(storedNewEmail);

    const getemail = localStorage.getItem("email");
    setOldEmail(getemail);

    if (queryParams.get("email")) {
      setOldEmail(queryParams.get("email"));
      resendotp(queryParams.get("email"));
    }

  }, []);

  const handleSubmit = async () => {
    if (otp.length !== 4) {
      return toast.error("Please enter complete OTP");
    }

    try {
      if (newEmail) {
        const encryptedData = JSON.stringify({
          otp: otp,
          oldEmail: oldEmail,
          newEmail: newEmail,
        });

        const res = await axiosInstance.post("/verifyEmail", encryptedData);

        if (res?.data?.status) {
          toast.success(res?.data?.message);
          localStorage.removeItem("email");
          navigate("/log-in");
        } else {
          toast.error(res?.data?.message);
        }
      } else {
        const encryptedData = JSON.stringify({
          otp: otp,
          email: oldEmail,
        });

        const res = await axiosInstance.post("/verifyOtp", encryptedData);

        if (res?.data?.status) {
          toast.success(res?.data?.message);
          localStorage.removeItem("email");
          navigate("/log-in");
        } else {
          toast.error(res?.data?.message);
        }
      }
    } catch (error) {
      toast.error("Verification failed");
    }
  };


  const resendotp = async (email) => {
    try {
      const res = await axiosInstance.post("/resendOtp", {
        email: email,
      });

      if (res?.data?.status) {
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("Unable to resend OTP");
    }
  };

  const pillPrimary =
    "w-full flex items-center justify-center gap-2 rounded-full bg-[#097FE6] hover:bg-[#0866c4] text-white py-3.5 text-sm sm:text-base font-medium transition";

  return (
    <section className="min-h-screen flex flex-col lg:flex-row bg-white">
      <div className="order-1 flex flex-1 justify-center items-center flex-col lg:order-none lg:w-1/2 lg:min-h-screen px-4 xl:pl-24 pt-8 pb-10 lg:py-12">
        <button
          type="button"
          onClick={() => navigate("/")}
          className="shrink-0 self-center xl:mt-0 mt-10 xl:self-start mb-6 rounded-md outline-none focus-visible:ring-2 focus-visible:ring-[#097FE6] focus-visible:ring-offset-2 flex items-center gap-2"
          aria-label="Go to home"
        >
          <img
            src={homeLogo}
            alt="My Real Estate"
            className="h-8 w-auto max-w-[50px] object-left object-contain cursor-pointer -mt-2"
          />
          <p className="text-xl font-semibold text-[#000929]">
            myrealestate-ng.com
          </p>
        </button>

        <div className="flex flex-1 flex-col justify-center w-full max-w-md mx-auto lg:mx-0">
          <h1 className="xl:text-left text-center text-2xl sm:text-[40px] font-semibold text-[#000929] tracking-tight mb-8 sm:mb-10">
            Verify your email
          </h1>
          <p className="text-sm text-[#6B7280] xl:text-left text-center mb-4">
            Enter the 4-digit OTP sent to your email.
          </p>

          {/* <button
            type="button"
            className="text-sm text-[#097FE6] font-medium mb-6 self-start hover:underline w-full text-left"
            onClick={() => navigate("/log-in")}
          >
            ← Back to login
          </button> */}

          <div className="flex justify-center mb-6 w-full">
            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={4}
              shouldAutoFocus
              containerStyle={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "14px",
              }}
              renderInput={(props) => (
                <input
                  {...props}
                  inputMode="numeric"
                  pattern="[0-9]*"
                  className="
        !w-10 !h-10
        sm:!w-12 sm:!h-12
        text-xl sm:text-2xl
        font-semibold
        text-center
        border-2 border-[#E5E7EB]
        rounded-xl
        bg-white
        focus:border-[#097FE6]
        focus:outline-none
        focus:ring-0
        outline-none
        transition-all duration-200
        flex-shrink-0
        text-[#333F48]
      "
                />
              )}
            />
          </div>

          <div className="flex justify-center mb-6 w-full">
            <button
              type="button"
              className="text-sm text-[#097FE6] font-semibold hover:underline"
              onClick={() => resendotp(oldEmail)}
            >
              Resend OTP
            </button>
          </div>

          <button type="button" className={pillPrimary} onClick={handleSubmit}>
            Verify OTP
          </button>

          <button
            type="button"
            className="mt-4 w-full text-sm font-semibold text-[#097FE6] underline underline-offset-2 decoration-[#097FE6] hover:text-[#0866c4] hover:decoration-[#0866c4] text-center"
            onClick={() => navigate("/")}
          >
            Back to home
          </button>
        </div>

        <p className="mt-auto pt-6 xl:pt-10 text-xs sm:text-sm text-[#9CA3AF] max-w-md mx-auto lg:mx-0 lg:max-w-none xl:text-left text-center">
          By continuing, you agree to our{" "}
          <span className="underline text-[#000929] cursor-pointer">Terms of Service</span>
          {" "}
          and{" "}
          <span className="underline text-[#000929] cursor-pointer">Privacy Policy</span>
          .
        </p>
      </div>

      <div
        className="order-2 w-full min-h-[240px] sm:min-h-[320px] lg:order-none lg:w-1/2 lg:min-h-screen items-center justify-center px-8 py-10 lg:p-12 bg-gradient-to-l from-[#097FE6] to-[#FFFFFF] xl:flex hidden"
        aria-hidden
      >
        <img
          src={loginHero}
          alt=""
          className="w-full max-w-[min(100%,420px)] lg:max-w-[min(100%,614px)] h-auto object-contain select-none pointer-events-none"
        />
      </div>
    </section>
  );
};

export default VerifyOtp;
